import React from 'react';
import HTMLEditorChatbot from './components/HTMLEditorChatbot';

function App() {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        background: '#0D0D0D',
        margin: 0,
        padding: 0,
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        overflow: 'hidden',
      }}
    >
      <HTMLEditorChatbot />
    </div>
  );
}

export default App;
